import {convertToHours, diffInMinutes} from "../resources/activity/utils";
import {
    BASE,
    WINDOW,
    LAUNDRY,
    COMMISSION,
    BASE_DURING_COMMISSION_DAY,
} from "../resources/activity/constants";

const sum = (a, b) => a + b;

export const groupBy = (xs, key) => {
    return xs.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const activityPrice = (hours, bonus, activityType, hourlyRates, bonusHourlyRate) => {
    const baseRate = hourlyRates?.BASE || 0
    const windowRate = hourlyRates?.WINDOW || 0
    const laundryRate = hourlyRates?.LAUNDRY || 0
    const commissionRate = hourlyRates?.COMMISSION || 0
    const baseDuringCommissionDayRate = hourlyRates?.BASE_DURING_COMMISSION_DAY || 0
    const bonusRate = bonusHourlyRate || 0

    switch (activityType) {
        case BASE:
            return hours * baseRate + hours * bonusRate * bonus / 100;
        case WINDOW:
            return hours * windowRate + hours * bonusRate * bonus / 100;
        case LAUNDRY:
            return hours * laundryRate + hours * bonusRate * bonus / 100;
        case COMMISSION:
            return hours * commissionRate + hours * bonusRate * bonus / 100;
        case BASE_DURING_COMMISSION_DAY:
            return hours * baseDuringCommissionDayRate + hours * bonusRate * bonus / 100;
        default:
            return hours * baseRate + hours * bonusRate * bonus / 100;
    }
};

export const orderPricePerParticipant = (employee, {
    duty,
    oneTimeDuty,
    assignee,
    helpers,
    bonus,
    overrideMinutes,
    overrideActivityType
}, workingHours) => {
    if (!employee)
        return 0;

    const numberOfParticipants = (helpers?.length || 0) + (assignee ? 1 : 0);
    if (numberOfParticipants === 0)
        return 0;

    const activities = (duty || oneTimeDuty).activities;
    const defaultActivityType = overrideActivityType || (activities?.length > 0 && activities[0]?.type);

    if (overrideMinutes !== null) {
        const hours = convertToHours(overrideMinutes);
        return activityPrice(hours / numberOfParticipants, bonus, defaultActivityType, employee?.hourlyRates, employee?.bonusHourlyRate)
    }

    if (workingHours > 0) {
        return activityPrice(workingHours / numberOfParticipants, bonus, defaultActivityType, employee?.hourlyRates, employee?.bonusHourlyRate)
    }

    if (!activities) {
        return 0;
    }

    return activities.map(a => {
        const hours = convertToHours(a.minutes);
        return activityPrice(hours / numberOfParticipants, bonus, overrideActivityType || a.type, employee?.hourlyRates, employee?.bonusHourlyRate)
    }).reduce(sum, 0)

}

export const orderPrice = (order) => {
    const participants = [order?.assignee, ...(order?.helpers || [])].filter(Boolean);
    const workingHours = convertToHours(diffInMinutes(order?.startRealizationDateTime, order?.endRealizationDateTime));

    return Math.round(participants
        .map(employee => orderPricePerParticipant(employee, order, workingHours))
        .reduce(sum, 0)
    * 100) / 100;
}